/* ============================================================================
   DAILE custom — Кастомайзер, модуль состояния (TASK39, срез Ф0).
   ТЗ: CUSTOMIZER_TZ_v3.md §1 — единый источник состояния, ререндер при изменении;
   реактивность даёт дисциплина, не фреймворк. Грузится ПЕРЕД daile-customizer.js
   (оба defer из sections/daile-customizer.liquid — порядок тегов сохраняется).
   Единственный глобал моста между файлами: window.DaileCustomizer.
   Правило: state НЕ мутировать напрямую — только store.set(patch) / store.merge().
   ============================================================================ */
(function () {
  'use strict';

  if (window.DaileCustomizer) return; // защита от двойной загрузки

  /* Порядок шагов = порядок панелей в секции (ТЗ §5).
     TASK96: 'puzzle' слит с 'upload' (сетка прямо на кропе), 'extras' скрыт
     (апсейлы живут в дровере корзины). state.extras остаётся в форме состояния —
     Review/чекаут читают его как раньше (всё false). */
  var STEPS = ['upload', 'gift', 'review'];

  /* Полная форма состояния под P0 (ТЗ §17). Срез Ф0 использует только step /
     maxStepReached / size; остальные поля заполнят срезы 2–8 — форма
     зафиксирована заранее, чтобы срезы не изобретали её каждый по-своему. */
  var initialState = {
    step: 0,            // индекс в STEPS
    maxStepReached: 0,  // до какого шага дошёл клиент (для кликов по прогрессу)
    size: '1000',       // '1000' | '500' | '300' — [P1], в MVP только 1000

    photo: null,        // TASK41: { url (objectURL до среза 9, потом CDN), width, height, quality: 'green'|'yellow'|'red' }
    crop: { zoom: 1, nx: 0, ny: 0 },  // TASK44: zoom 1..3, nx/ny — offset в ДОЛЯХ зоны (масштаб-независимо: зоны Upload/Puzzle/print-скрипт разных размеров)
    orientation: 'v',   // 'v' | 'h' — тумблер на Upload (TASK40); срез 2 добавит авто-детект по фото, тумблер останется ручным переопределением

    box: {              // срез 4 (Шаг 2 ТЗ §3): вариант композиции крышки + текст
      variant: 'default',   // 'default' | 'photo-only' | 'no-daile'
      position: 'center',   // для photo-only: 'left' | 'center' | 'right' (V); H — только center
      text: '',
      font: 'cormorant',    // 'cormorant' | 'hanken'
      sizePreset: 'l',      // TASK47/48: 's'|'l' — доля от автоподбора-до-влезания (заменил fontSize 40–80 из ТЗ §7); TASK53: дефолт Large; финальные mockup-единицы кладёт контроллер в DaileCustomizer.derived
      color: '#B4B4B4'      // или '#161514'
    },

    nfc: { enabled: false, url: '' },        // декуплен (ТЗ §5 NFC), placement решается позже

    card: {                                  // срез 5 (Шаг 3): карточка-апсейл €18
      added: false,
      text: '',
      font: 'cormorant',    // TASK50: те же контролы, что у крышки (был [P1] ТЗ)
      sizePreset: 'l',      // 's' | 'l' (TASK53: дефолт Large)
      color: '#161514',     // на белой карточке дефолт — чёрный
      align: 'justify'      // TASK78 п.5: left | center | right | justify
    },

    extras: {                                // срез 6 (Шаг 4)
      bag: false,
      magnets: false,
      frameInterest: false                   // interest-signal, не покупка (ТЗ §9)
    }
  };

  /* store: getState / set (верхний уровень) / merge (patch вложенного объекта) /
     subscribe. Каждый set/merge синхронно зовёт всех подписчиков с новым state. */
  function createStore(initial) {
    var state = initial;
    var listeners = [];

    function notify() {
      for (var i = 0; i < listeners.length; i++) {
        try {
          listeners[i](state);
        } catch (e) {
          console.error('[daile-customizer] подписчик store упал', e);
        }
      }
    }

    return {
      getState: function () { return state; },

      /* set({ step: 2 }) — шаллоу-мердж верхнего уровня */
      set: function (patch) {
        var next = {};
        var k;
        for (k in state) { if (state.hasOwnProperty(k)) next[k] = state[k]; }
        for (k in patch) { if (patch.hasOwnProperty(k)) next[k] = patch[k]; }
        state = next;
        notify();
      },

      /* merge('box', { text: 'Hi' }) — патч вложенного объекта без затирания соседей */
      merge: function (key, patch) {
        var branch = {};
        var cur = state[key] || {};
        var k;
        for (k in cur) { if (cur.hasOwnProperty(k)) branch[k] = cur[k]; }
        for (k in patch) { if (patch.hasOwnProperty(k)) branch[k] = patch[k]; }
        var top = {};
        top[key] = branch;
        this.set(top);
      },

      subscribe: function (fn) {
        listeners.push(fn);
        return function () {
          var idx = listeners.indexOf(fn);
          if (idx > -1) listeners.splice(idx, 1);
        };
      }
    };
  }

  window.DaileCustomizer = {
    STEPS: STEPS,
    store: createStore(initialState)
  };
})();
